var _path, _g, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 40 38",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "______src_modules_common_svg_IcoBalance_svg__a",
    width: 36,
    height: 11,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h36v10H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#______src_modules_common_svg_IcoBalance_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.818,
    height: 13.882,
    x: 4.83,
    y: 8.479,
    stroke: "#fff",
    strokeWidth: 2,
    rx: 3,
    transform: "rotate(-14.497 4.83 8.48)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M22 20.5a3 3 0 0 1 3-3h13a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H25a3 3 0 0 1-3-3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 23,
    r: 1.5,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6 10.5h27a2 2 0 0 1 2 2v6h2v-6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v21a4 4 0 0 0 4 4h27a4 4 0 0 0 4-4v-6h-2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-21a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBalance);
export default __webpack_public_path__ + "static/media/IcoBalance.fa243257615f7dfe4d51df0f60cd86fa.svg";
export { ForwardRef as ReactComponent };